import { LayoutService } from '@shared/services/layout/layout.service';
import { BrowserStorageService } from '@core/services/browser-storage/browser-storage.service';

const MESSAGES = {
  forbidden: {
    ar: 'ليس لديك الصلاحية الكافية لتنفيذ هذا الإجراء.',
    en: 'You do not have permission to perform this action.',
  },
  tooManyRequests: {
    ar: 'لقد تم الوصول الى الحد المسموح به للطلبات. يرجى المحاولة مرة أخرى لاحقاً.',
    en: 'You have reached the maximum number of requests. Please try again later.',
  },
} as const;

type MessageKey = keyof typeof MESSAGES;

/** Bypasses TranslateService — it has a circular dependency with the interceptor chain. */
export function notifyLocalizedError(
  layoutService: LayoutService,
  browserStorageService: BrowserStorageService,
  key: MessageKey
): void {
  const currentLang = browserStorageService.get('currentLang') || 'ar';
  const text = currentLang === 'ar' ? MESSAGES[key].ar : MESSAGES[key].en;
  layoutService.$notifyToaster.next({ text, type: 'error' });
}
